import { Component } from 'react'
import { Reward } from 'interfaces/bounty'
import * as cn from 'classnames'
import * as styles from 'components/features/pfm/RewardDetails/Progress.css'
import { RewardsStatusInColor } from 'components/features/pfm/RewardDetails/RewardStatusInColor/RewardStatusInColor'

type ProgressProps = {
  status: Reward['status']
  onClick: () => void
}

const CLASS_NAME_FOR_STATUS: Partial<Record<Reward['status'], string>> = {
  confirmed: styles.confirmed,
  earned: styles.earned,
  expired: styles.expired,
  pending: styles.pending,
}

class Progress extends Component<ProgressProps> {
  render () {
    const { status, onClick } = this.props

    return (
      <div className={ cn(styles.progress, CLASS_NAME_FOR_STATUS[status]) } onClick={ onClick }>
        <div className={ styles.progressInner }>
          { this.renderCircles(status) }
        </div>
      </div>
    )
  }

  renderCircles (status: Reward['status']) {
    if (status === 'cryptoCancelled') {
      return null
    }
    if (status === 'cryptoConfirmed' || status === 'cryptoPending') {
      return this.renderCirclesCrypto(status)
    }
    return this.renderCirclesCash(status)
  }

  renderCirclesCash (status: Reward['status']) {
    if (status === 'expired') {
      return null
    }
    if (status === 'confirmed') {
      return (
        <>
          <RewardsStatusInColor className={ styles.circle } status={ status } withBackgroundColor />
          <RewardsStatusInColor className={ styles.circle } status={ status } />
          <RewardsStatusInColor className={ styles.circle } status={ status } withBackgroundColor />
        </>
      )
    }
    if (status === 'pending') {
      return (
        <>
          <RewardsStatusInColor className={ styles.circle } status={ status } withBackgroundColor />
          <RewardsStatusInColor className={ styles.circle } status={ status } withBackgroundColor asEmptyCircle />
          <RewardsStatusInColor className={ styles.circle } status={ status } withBackgroundColor asEmptyCircle />
        </>
      )
    }
    return (
      <>
        <RewardsStatusInColor className={ styles.circle } status={ status } withBackgroundColor />
        <RewardsStatusInColor className={ styles.circle } status={ status } withBackgroundColor />
        <RewardsStatusInColor className={ styles.circle } status={ status } withBackgroundColor asEmptyCircle={ status !== 'earned' } />
      </>
    )
  }

  renderCirclesCrypto (status: Reward['status']) {
    return (
      <>
        <RewardsStatusInColor className={ styles.circle } status={ status } withBackgroundColor />
        <RewardsStatusInColor className={ styles.circle } status={ status } />
        <RewardsStatusInColor className={ styles.circle } status={ status } withBackgroundColor asEmptyCircle={ status === 'cryptoPending' } />
      </>
    )
  }
}

export default Progress
